// https://vuex.vuejs.org/en/mutations.html

export default {
  setCurrentPortfolioViewed (state, val) {
    state.currentPortfolioViewed = val
  },

  setCMSNavigationStatus (state, val) {
    state.cmsNavigationStatus = val
  }
}
